<template>
  <main>
    <div v-if="!loading">
      <div class="container-fluid mt-3" style="width: 100%;max-width: 1200px;">
        <div class="row m-3" v-if="erro">
          <div class="col card my-2 badge-danger text-center p-3 text-uppercase mt-3">
            {{ erro }}
          </div>
        </div>
        <div class="products">
          <div class="pagina-carousel">
            <div class="card mt-3" v-for="(item, index) of descontos" :key="index">
              <div class="card-body">
                <h3 class="categoria-produto" :id="item.category.id">
                  <i>
                    <img :src="item.category.urlIcon" width="16" height="16" class="bi" />
                  </i>
                  <span class="categoria-produto">{{ item.category.name }}</span>
                  <span class="d-none">{{ item.category.id }}</span>
                </h3>
                <div class=" grid-container">
                  <div v-for="offer of descontos[0].offers" :key="offer.id" class="grid-item">
                    <div class="card-item-carousel cursor" @click="openOffer(offer.id)">
                      <div class="foto-protudo"
                        v-bind:style="{ 'background-image': 'url(' + imagemOffer(offer.urlImage) + ')' }">
                      </div>
                      <div class="carousel-texto">
                        <div class="descricao-protudo mt-1"><strong> {{ offer.title }}</strong></div>
                        <div class="preco-protudo mt-2">{{ offer.benefitsText }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Loading v-if="loading"></Loading>
  </main>
</template>

<script>

import Loading from "@/components/Loading.vue";

import { authApp, authUser } from "../service/clube/serviceAuthAPI";
import {
  getOffersByCategoryId,
} from "../service/clube/serviceClubeAPI";

export default {
  name: "ClubeDescontoCategoriaNew",
  components: { Loading },
  data() {
    return {
      erro: "",
      loading: false,
      descontos: null,
      categorias: [],
      showCarousel: true,
      search: "",
      listaCarrosel: [],
    };
  },
  mounted() {
    this.loading = true
    let userCode = this.$route.query.userCode ? this.$route.query.userCode : localStorage.getItem("accessToken");

    authApp().then(auth => {
      if (auth.code === "200") {
        localStorage.removeItem("token_api_sso");
        localStorage.setItem("token_api_sso", auth.data.token);
        if (userCode) {
          const user = { grantType: "access_token", userCode: userCode };

          authUser(user).then(authUser => {
            if (authUser.code === "200") {
              localStorage.removeItem("token_api_sso");
              localStorage.setItem("token_api_sso", authUser.data.token);
              this.getOffersByCategoryId(this.$route.params.categoryId);
            }
          }).catch(error => {
            this.erro = `500 - ${error.data}`;
          })
        } else {
          this.getOffersByCategoryId(this.$route.params.categoryId);
        }
      }
    });
  },
  methods: {
    openOffer(id) {
      const route = this.$route.path.replace(`categoria/${this.$route.params.categoryId}`, "");
      this.$router.push(`${route}${id}`)
    },
    imagemOffer(imagem) {
      if (imagem === null) return 'https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png';
      return imagem;
    },
    getOffersByCategoryId(id) {
      this.erro = "";
      this.loading = true
      getOffersByCategoryId(id).then(offer => {
        if (offer.code === '200') {
          this.descontos = offer.data;
          this.loading = false
        }
      }).catch(error => {
        this.erro = `500 - ${error.data}`;
      })
    },
    urlImage(imagemUrl) {
      return `url('${imagemUrl ||
        "https://pagglo-cdn.s3.amazonaws.com/app/assets/sem_foto.png"}')`;
    },
  }
};
</script>
<style scoped lang="scss">
.card {
  background-color: var(--cor-home-card) !important;
}

h3.categoria-produto {
  font-size: 1rem;
  text-transform: uppercase;
  margin-bottom: 1rem;
  color: var(--cor-secundaria) !important;
  font-weight: 700;
}

span.categoria-produto {
  margin-left: 8px;
}

img.bi {
  margin-top: -2px;
}

img {
  border-radius: 20px;
}

.cursor {
  cursor: pointer;
}

.card-item-carousel {
  background-color: var(--cor-home-card) !important;
  color: var(--cor-home-texto-card-item) !important;
  border: 1px solid #ececec;
  border-radius: 8px;
  height: 275px;
  width: 195px;
}

.card-item-carousel:hover {
  box-shadow: 0 0 11px rgba(33, 33, 33, .2) !important;
}

.owl-stage-outer {
  padding: 10px 0px;
}

.foto-protudo {
  width: 100%;
  min-height: 140px;
  background-size: cover;
  background-position: center;
  -webkit-border-top-left-radius: 8px;
  -webkit-border-top-right-radius: 8px;
  -moz-border-radius-topleft: 8px;
  -moz-border-radius-topright: 8px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}

.container-fluid {
  .banner {
    padding: 15px;
  }
}

.carousel {
  width: 100%;
  padding: 5px;
}

.corpo-carousel {
  width: calc(100% - 10px);
  display: inline-block;
}

.carousel-texto {
  padding: 15px;
  margin-top: -20px;
  text-align: center;
}

.card-item-carousel {
  max-height: 340px;
  margin-bottom: 15px;
}

.owl-item.active {
  margin-right: 10px;
}

.grid-container {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.grid-item {
  padding: 10px;
}

@media (max-width: 770px) {

  .owl-item.active {
    margin-right: 5px;
  }

  .descricao-protudo {
    font-size: 0.85rem;
  }

  .carousel-texto {
    padding: 5px;
  }

  .preco-protudo {
    font-size: 0.85rem;
  }

  .unidade-protudo {
    font-size: 0.75rem;
  }

  .foto-protudo {
    min-height: 110px;
    max-width: 110px;
  }

  .card-body {
    padding: 0.1rem;
  }

  .card-item-carousel {
    height: 218px;
    width: 136px;
    margin-left: 10px;
    margin-bottom: 10px;
  }

  .categoria-produto {
    padding-left: 10px;
    margin-top: 5px;
  }

  .carousel {
    padding: 0px;
  }

  .carousel-texto {
    padding: 10px;
  }

  .grid-container {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
